<table mat-table [dataSource]="dataSource"
       matSort matSortActive="run_start_time" matSortDisableClear matSortDirection="asc">
  <ng-container matColumnDef="run_start_time">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Run Start Time</th>
    <td mat-cell *matCellDef="let row">{{ row.runStartTime.toDate() | date: 'short' }}</td>
  </ng-container>

  <ng-container matColumnDef="impacted_customers">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Customers Impacted</th>
    <td mat-cell *matCellDef="let row">{{ row.customersImpacted | number }}</td>
  </ng-container>


  <ng-container matColumnDef="total_customers">
    <th mat-header-cell *matHeaderCellDef>Total Customers</th>
    <td mat-cell *matCellDef="let row">{{ row.totalCustomers | number}}</td>
  </ng-container>

  <ng-container matColumnDef="highThreshold">
    <th mat-header-cell *matHeaderCellDef>High Threshold</th>
    <td mat-cell *matCellDef="let row">{{ row.highThreshold| number}}</td>
  </ng-container>

  <ng-container matColumnDef="lowThreshold">
    <th mat-header-cell *matHeaderCellDef >Low Threshold</th>
    <td mat-cell *matCellDef="let row">{{ row.lowThreshold | number }}</td>
  </ng-container>

  <ng-container matColumnDef="morethanHighThreshold">
    <th mat-header-cell *matHeaderCellDef class="center-cell">Over High Threshold</th>
    <td mat-cell *matCellDef="let row" class="center-cell">
      <mat-icon>{{(row.morethanHighThreshold)? 'check' :'close'}}</mat-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="morethanLowThreshold">
    <th mat-header-cell *matHeaderCellDef class="center-cell">Over Low Threshold</th>
    <td mat-cell *matCellDef="let row" class="center-cell">
      <mat-icon>{{(row.morethanLowThreshold)? 'check' :'close'}}</mat-icon>
    </td>
  </ng-container>


  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let row; columns: columns;"></tr>
</table>
<mat-paginator pageSize="5" hidePageSize aria-label="Select page of metrics"></mat-paginator>
